export const sliderTexts = [
  {
    title: "Surprisingly helpful",
    text: "I have asked dozens of questions and have learned a lot by doing so. It’s like having a very wise, educated friend give you the straight answer every time.",
    author: "Sophia_Martinez_92",
  },
  {
    title: "Very Informative!",
    text: "I really love the way I can do many things on it like get answers and summaries and that there is an AI Bot that is really nice and informative.",
    author: "emmaturner12",
  },
  {
    title: "Excellent",
    text: "Wow, very impressive indeed. Give it all the ideas and it puts it together so perfectly!!",
    author: "MatthewParker9889",
  },
  {
    title: "The best!",
    text: "This is amazing and helpful!",
    author: "Mia_Ns87675",
  },
  {
    title: "Appreciate",
    text: "I really enjoyed using chaton and thanks for making everything easier for us to be using it.",
    author: "noah1Thomson_",
  },
  {
    title: "Just wow!",
    text: "It's amazing how it can turn anything you need from a text to an email to a report into an amazing world of art that makes you sound educated, eloquent and smart. Love it",
    author: "EthanSmith_87",
  },
];

export const comparisonTableTexts = [
  {
    feature: "ACCESS TO GPT-4o mini",
    explanation: "Have a simple chat with AI",
    isFreeContains: true,
    isProContains: true,
    icon: "table-icon-stars",
  },
  {
    feature: "ACCESS TO GPT-4o",
    explanation: "Get more in-depth answers",
    isFreeContains: false,
    isProContains: true,
    icon: "table-icon-gpt",
  },
  {
    feature: "IMAGE GENERATION",
    explanation: "Turn words into images",
    isFreeContains: false,
    isProContains: true,
    icon: "table-icon-picture",
  },
  {
    feature: "NO LIMITS",
    explanation: "Chat without boundaries",
    isFreeContains: false,
    isProContains: true,
    icon: "table-icon-infinity",
  },
  {
    feature: "FASTER RESPONSES",
    explanation: "Find what you need in no time",
    isFreeContains: false,
    isProContains: true,
    icon: "table-icon-spark",
  },
  {
    feature: "WEB-MOBILE SYNC",
    explanation: "Buy once, use anywhere! Access subscriptions and chat history across all devices.",
    isFreeContains: false,
    isProContains: true,
    icon: "table-icon-whatsapp",
  },
];
